export default __webpack_public_path__ + "fonts/ai_3.c33a6c825148a32f4c9cc75db6ddb62e.png";